"use strict";

// init modal on page load when the modal is in the html structure (back-in-stock-modal-success.html.twig)
export function initInScope($scope) {
    try{
        $scope.find('.js-init-modal').modal('show');
    }catch(e){
        console.log(e);
    }
}